import React, { useLayoutEffect, useState, ReactNode, useEffect } from "react";
import "./accordion.scss";

export interface AccordionProps {
  isAccordionOpen: boolean;
  children?: ReactNode;
  id: string;
}

export function Accordion({ children, id, isAccordionOpen }: AccordionProps) {
  const [containerHeight, setContainerHeight] = useState<number>(0);

  useEffect(() => {
    const accordionContainer = document.getElementById(id);
    setContainerHeight(accordionContainer?.clientHeight);
    console.log(
      "getting container height: " + accordionContainer?.clientHeight
    );
  }, [isAccordionOpen]);

  return (
    <div
      style={{ height: isAccordionOpen ? containerHeight : 0 }}
      className={`accordion${isAccordionOpen ? " accordion--open" : ""}`}
    >
      <div id={id} className="accordion__container">
        {children}
      </div>
    </div>
  );
}
